import {
  Box,
  Typography,
} from '@mui/material';

// -----------------------------------------

export default function OnboardingCard() {
  return (
    <Box sx={{ p: 3, borderRadius: 2, backgroundColor: "grey.100", mb: 2 }}>
      <Typography variant="h6" gutterBottom>
        🎉 첫 한 달간 온보딩 데일리 투두를 제공하고 있어요.
      </Typography>
      <Typography variant="body2">
        새 크루와의 성공적인 협업을 위해 데일리 투두를 제공하고 있어요.
      </Typography>
    </Box>
  )
}